import { css } from 'styled-components';

export const updateEmailContainer = css`
  padding-bottom: var(--bc-sizes-72);

  ${({ theme }) => theme.device.laptop} {
    padding-bottom: 0;
  }
`;
